import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import TextboxControl from "../../../components/Fields/TextboxControl";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import ProductCategoryModel from "../../../models/ProductCategoryModel";
import ProductCategoryReferenceModel from "../../../models/ProductCategoryReferenceModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface ProductCategoryReferencesUpdateModel {
    productCategoryId: number
    productCategoryReferences: ProductCategoryReferenceModel[]
}

interface Props {
    show: boolean
    onHide: () => void
    productCategory: ProductCategoryModel
}

const EditProductCategoryReferencesPopup: React.FC<Props> = ({ show, onHide, productCategory }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ProductCategoryReferencesUpdateModel>();

    useEffect(() => {
        DataService.get<ProductCategoryReferenceModel[]>('api/v1/ProductCategoryReferences/ByProductCategory/' + productCategory.id)
            .then(response => {
                setFormData({
                    productCategoryId: productCategory.id,
                    productCategoryReferences: response
                })
            })
    }, [productCategory]);

    function submit() {
        if (formData) {
            DataService
                .update(`api/v1/ProductCategoryReferences`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData?.productCategoryReferences) {
        formData.productCategoryReferences.forEach((productCategoryReference, index) => {
            formConfig.fields.push({ name: `ProductCategoryReferences.${index}.referenceCode`, label: productCategoryReference.externalSystemName, validationRules: [{ type: 'isMaxLength', maxLength: 50 }] });
            formConfig.fields.push({ name: `ProductCategoryReferences.${index}.readyForExportOn`, label: 'Ready for export on' });
            formConfig.fields.push({ name: `ProductCategoryReferences.${index}.exportedOn`, label: 'Exported on' });
        })
    }

    const { getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Edit external references'} >
            <Popup.Body>
                {formData?.productCategoryReferences && formData.productCategoryReferences.length > 0 && (
                    <>
                        <table>
                            <tr>
                                <th className='col-md-2'></th>
                                <th className='col-md-6'><Translate>Reference code</Translate></th>
                                <th className='col-md-2'><Translate>Ready for export</Translate></th>
                                <th className='col-md-2'><Translate>Exported</Translate></th>
                            </tr>
                            {formData.productCategoryReferences.map((productCategoryReference, index) => {
                                return (
                                    <tr>
                                        <td><Form.Label>{productCategoryReference.externalSystemName}</Form.Label></td>
                                        <td><TextboxControl {...getControlProps(`productCategoryReferences.${index}.referenceCode`)} key={index} /></td>
                                        <td><DateControl {...getControlProps(`productCategoryReferences.${index}.readyForExportOn`)} disabled key={index} /></td>
                                        <td><DateControl {...getControlProps(`productCategoryReferences.${index}.exportedOn`)} disabled key={index} /></td>
                                    </tr>
                                )
                            })
                            }
                        </table>
                    </>
                )}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default EditProductCategoryReferencesPopup;